import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
// import toaster from 'utils/toaster';

export interface ISaveTimesheetData {
  id: string;
  user_id: number;
  job_id: number;
  task_id: number;
  start: string | Date;
  end: string | Date;
  latitude: string;
  longitude: string;
  in_source: string;
  out_source: string;
  notes: string;
  mileage: number;
  isPto: number;
  timezone: string;
  images: string[];
  breaks: string;
  lunch_break_duration: string;
  custom_fields: any;
}

const saveTimesheet = ({ id, ...postData }: ISaveTimesheetData) => {
  const postFormData: any = new FormData();
  for (const key in postData) {
    // @ts-ignore
    let value: any = postData[key];
    if (key === 'breaks') {
      value = JSON.stringify(postData[key]);
    }
    if (key === 'custom_fields') {
      value = JSON.stringify(postData[key]);
    }
    postFormData.append(`${key}`, value);
  }

  if (id) {
    postFormData.append('_method', 'PUT');
    const newEndpoints = endpoints.timesheet.timesheetById.replace('{id}', id);
    return http('multipart').post(newEndpoints, postFormData);
  } else {
    return http('multipart').post(endpoints.timesheet.base, postFormData);
  }
};

export function useSaveTimesheet() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveTimesheet,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchPaginatedTimesheet'] });
        queryClient.invalidateQueries({ queryKey: ['fetchTabItemCountByModule', 'timesheet'] });
      }
    },
  });
}
